import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Tab, Nav, Badge, Dropdown, Button, Carousel } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import staff1 from '../../../../images/staff/member_2.png';
import staff2 from '../../../../images/staff/member_1.png';
// import "../../Human_Resource/attendance/Attendance.css";
import "./Attendance.css";
import Present from './../../../modal/hr_management/attendance/Present';
import Absent from './../../../modal/hr_management/attendance/Absent';
import Leave from './../../../modal/hr_management/attendance/Leave';
import Permission from './../../../modal/hr_management/attendance/Permission';
import Edit from './../../../modal/hr_management/attendance/Edit';
import View from './../../../modal/hr_management/attendance/View';
import present from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import Drawer from '@mui/material/Drawer';
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from 'react-toastify';
import axios from 'axios';



const Attendance = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [key, setKey] = useState(2);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [attendanceData, setAttendanceData] = useState([]);
    const [error, setError] = useState(null);
    const [selectedStaffId, setSelectedStaffId] = useState(null);
    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);
    const [open, setOpen] = useState(false);
    // const [selectedMonth, setSelectedMonth] = useState(6);
    const [selectedAttendanceId, setSelectedAttendanceId] = useState(null);
    const [initialData, setInitialData] = useState(null);
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [hasFetched, setHasFetched] = useState(false);
    const [TotalCount, setTotalCount] = useState('');
    const [percentages, setPercentages] = useState({
        present: 0,
        leave: 0,
        permission: 0,
        onDuty: 0,
        weekEnd: 0,
    });
    
    const currentDate = new Date(); // Current date: June 18, 2025
    const currentMonth = currentDate.getMonth(); // 5 (June, 0-based index)
    const currentYear = currentDate.getFullYear(); // 2025

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ].slice(0, currentMonth + 1); // Only include up to June

    const [selectedMonth, setSelectedMonth] = useState(currentMonth + 1); // Set to current month (1-based for API)
    const [carouselIndex, setCarouselIndex] = useState(currentMonth);

    const handleSelect = (selectedIndex) => {
        setCarouselIndex(selectedIndex);
        setSelectedMonth(selectedIndex + 1); // 1-based for API
        setPage(1); // Reset to first page // Update selected month (1-based for API)
    };
    
    // const month = 6;  // June
    const year = 2025;

    const fetchAttendance = async (month = selectedMonth, year = currentYear) => {
        // const params = {
        //     page,
        //     per_page: perPage,
        //     search: searchTerm
        // };

        

        if (month > currentMonth + 1) {
            setError('Cannot fetch data for future months');
            setAttendanceData([]);
            return;
        }
        setError(null);

        try {
            const response = await axios.post(
                `${baseURL}/manageattendance/monthandyear`,
                // { month, year },            // body
                 {  month, year,page, per_page: perPage, search: searchTerm, branch_id: branch_id }                 // query params
            );

            // console.log("API Response Data:", response.data.data);
            // console.log("Is array?", Array.isArray(response.data.data));
            if (response.data.success) {
                setAttendanceData(response.data.data || []);
                setTotalPages(response.data.last_page);
                setTotalCount(response.data.count);
                setHasFetched(true);
            } else {
                setError('Failed to load attendance data');
                setAttendanceData([]);
                setHasFetched(true);
            }
        } catch (err) {
            setError('Error fetching attendance data');
            setAttendanceData([]);
            console.error('Error:', err);
            setHasFetched(true);
        }
    };

    useEffect(() => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchAttendance();
    }, [page, searchTerm, perPage, selectedMonth]);

    const attendance_type = [
        { value: "0", label: "Present", badge: "success", text: "P" },
        { value: "1", label: "Leave", badge: "danger", text: "L" },
        { value: "2", label: "Permission", badge: "warning", text: "Pr" },
        { value: "3", label: "On Duty", badge: "dark", text: "OD" },
        { value: "4", label: "Week End", badge: "info", text: "WK" },
    ];

    useEffect(() => {
        if (attendanceData.length === 0) {
            setPercentages({
                present: 0,
                leave: 0,
                permission: 0,
                onDuty: 0,
                weekEnd: 0,
            });
            return;
        }

        const counts = {
            present: 0,
            leave: 0,
            permission: 0,
            onDuty: 0,
            weekEnd: 0,
        };
        let totalRecords = 0;

        attendanceData.forEach((staff) => {
            const attendance = staff.attendance || {};
            Object.values(attendance).forEach((entry) => {
                const type = typeof entry === 'object' ? String(entry.type ?? "0") : String(entry);
                if (type === "0") counts.present++;
                else if (type === "1") counts.leave++;
                else if (type === "2") counts.permission++;
                else if (type === "3") counts.onDuty++;
                else if (type === "4") counts.weekEnd++;
                totalRecords++;
            });
        });

        const newPercentages = {
            present: totalRecords ? ((counts.present / totalRecords) * 100).toFixed(1) : 0,
            leave: totalRecords ? ((counts.leave / totalRecords) * 100).toFixed(1) : 0,
            permission: totalRecords ? ((counts.permission / totalRecords) * 100).toFixed(1) : 0,
            onDuty: totalRecords ? ((counts.onDuty / totalRecords) * 100).toFixed(1) : 0,
            weekEnd: totalRecords ? ((counts.weekEnd / totalRecords) * 100).toFixed(1) : 0,
        };

        setPercentages(newPercentages);
    }, [attendanceData]);

    // const dateKeys = attendanceData.length > 0 ? Object.keys(attendanceData[0].attendance) : [];
    const dateKeys = attendanceData.length > 0 ? Object.keys(attendanceData[0].attendance || {}) : [];
    
    const handleModalToggle = (staffId) => {
        console.log("handleModalToggle called with staffId:", staffId);
        setSelectedStaffId(staffId);
        setModalType("View");
        setOpen(true);
    };
    const handleModalPresent = () => {
        setModalType("Present");
        setOpen(true);
    };
    const handleModalAbsent = () => {
        setModalType("Absent");
        setOpen(true);
    };
    const handleModalLeave = () => {
        setModalType("Leave");
        setOpen(true);
    };
    const handleModalPermission = () => {
        setModalType("Permission");
        setOpen(true);
    };


    const handleModalEdit = (staff) => {
        const dateKey = dateKeys[0]; // e.g. "17/06 (Mon)"
        const dayData = staff.attendance?.[dateKey];
        // Safely extract fields
        let attendanceType = "0";
        let leaveTypeId = null;
        let reason = "";
        let startTime = "";
        let endTime = "";
        let permisionAbsent = null;
        let futurePermission = null;

        if (typeof dayData === 'object') {
            attendanceType = String(dayData.type ?? "0");
            leaveTypeId = dayData.leave_type_id || null;
            reason = dayData.reason || '';
            startTime = dayData.start_time || '';
            endTime = dayData.end_time || '';
            permisionAbsent = dayData.permision_absent ?? null;
            futurePermission = dayData.future_permission ?? null;
        } else if (typeof dayData === 'string' || typeof dayData === 'number') {
            attendanceType = String(dayData);
            // fallback to top-level
            leaveTypeId = staff.leave_type_id || null;
            reason = staff.reason || '';
        }

        setSelectedStaffId(staff.staff_id);
        setSelectedAttendanceId(staff.sno);

        setInitialData({
            ...staff,
            dateKey,
            attendance_type: attendanceType,
            leave_type_id: leaveTypeId,
            reason,
            start_time: startTime,
            end_time: endTime,
            permision_absent: permisionAbsent,
            future_permission: futurePermission,
            date: dateKey, // Optional: only if your modal needs the exact display date
        });

        setModalType("Edit");
        setOpen(true);
    };

    const onClose = () => {
        setFilterOpen(false);
    };

    const DeleteModal = (staff_id, staffName) => {
        // console.log("manageStaffId:", staff_id, "staffName:", staffName);
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Staff
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center">${staffName}</p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
            try {
                const response = await axios.delete(`${baseURL}/manageattendance/staff/${staff_id}`);
                if (response.data.message === "Attendance Deleted Successfully") {
                toast.success("Attendance has been deleted.");
                
                // Refresh data after deletion
                setAttendanceData(prevData => prevData.filter(item => item.manage_staff_id !== staff_id));
                // window.location.reload();
                }
            } catch (error) {
                console.error(error);
                swal.fire("Error!", "Failed to delete attendance.", "error");
            }
            }
        });
    };

    useEffect(() => {
        if (hasFetched && attendanceData.length >0 && tableRef.current) {
            const tableElement = $(tableRef.current);

            // Destroy previous instance
            if ($.fn.dataTable.isDataTable(tableElement)) {
            tableElement.DataTable().destroy();
            }

            // Initialize with scroll
            const dataTableInstance = tableElement.DataTable({
            responsive: true,
            ordering: false,
            paging: false,
            scrollX: true,
            searching: false,
            info: false,
            language: {
                lengthMenu: "Show _MENU_",
            },
            dom:
                "<'row'" +
                "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                ">" +
                "tr" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                ">",
                pageLength: perPage,
            });

            // Optional reflow
            dataTableInstance.columns.adjust().draw();

            return () => {
            if ($.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            };
        }
    }, [hasFetched, attendanceData]);

    const getBadgeProps = (status) => {
        if (status === undefined || status === null) {
            return { bg: 'secondary', text: '-' }; // Placeholder for no data
        }
        const statusStr = String(status);
        const type = attendance_type.find((t) => t.value === statusStr);
        return type
            ? { bg: type.badge, text: type.text }
            : { bg: 'secondary', text: '-' };
    };
    

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Attendance</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">HR Management</li>
                    </ol>
                </div>
                <div className='d-flex'>
                    <Link to={'/add-attendance'} className="btn btn-primary float-end btn-sm">
                        <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Attendance</span>
                    </Link>
                    {open && modalType === "View" && (
                        <View show={open} onClose={() => setOpen(false)} staffId={selectedStaffId} />
                    )}
                    {open && modalType === "Present" && (
                        <Present show={open} onClose={() => setOpen(false)} />
                    )}
                    {open && modalType === "Absent" && (
                        <Absent show={open} onClose={() => setOpen(false)} />
                    )}
                    {open && modalType === "Leave" && (
                        <Leave show={open} onClose={() => setOpen(false)} />
                    )}
                    {open && modalType === "Permission" && (
                        <Permission show={open} onClose={() => setOpen(false)}  />
                    )}
                    {open && modalType === "Edit" && (
                        <Edit show={open} onClose={() => setOpen(false)} staffId={selectedStaffId}
                            attendanceId={selectedAttendanceId}
                            initialData={initialData}
                            staffOptions={attendanceData} 
                            refresh={fetchAttendance}
                        />
                    )}
                </div>
            </div>
            <div className="table-container">
                <div className='row'>
                    {/* <div className='col-lg-4'></div> */}
                    <div className='col-lg-4'>
                        <div className='mb-3'>
                            <Carousel
                                controls={true}
                                activeIndex={carouselIndex}
                                onSelect={handleSelect}  // Dynamically update the active index
                                indicators={true}
                                interval={null}
                                nextIcon={carouselIndex === months.length - 1 ? null : undefined}
                            >
                                {months.map((month, idx) => (
                                <Carousel.Item key={idx} className='text-center'>
                                    <label className='fs-3 text-black fw-bold'>{month}</label>
                                    <div className='d-block'>
                                        <label className='fs-3 text-danger fw-bold'>{currentYear}</label>
                                    </div>
                                </Carousel.Item>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                    <div className='col-lg-8 d-flex align-items-center justify-content-end'>
                        <div className='me-2'>
                            <Badge bg="success" className='text-white fs-8 py-0 px-2 me-2'>P</Badge>
                            <label className='text-black fs-6'>Present</label>
                        </div>
                        <div className='me-2'>
                            <Badge bg="danger" className='text-white fs-8 py-0 px-2 me-2'>L</Badge>
                            <label className='text-black fs-6'>Leave</label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Leave With Intimation</span></Tooltip>} >
                                <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                    <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <div className='me-2'>
                            <Badge bg="warning" className='text-white fs-8 py-0 px-2 me-2'>Pr</Badge>
                            <label className='text-black fs-6'>Permission</label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>30 M - 30 Minutes<br></br>01 H - 01 Hour<br></br>0.5 D - Half Day</span></Tooltip>} >
                                <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                    <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <div className='me-2'>
                            <Badge bg="dark" className='text-white fs-8 py-0 px-2 me-2'>OD</Badge>
                            <label className='text-black fs-6'>On Duty</label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>30 M - 30 Minutes<br></br>01 H - 01 Hour<br></br>0.5 D - Half Day</span></Tooltip>} >
                                <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                    <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <div className='me-2'>
                            <Badge bg="info" className='text-white fs-8 py-0 px-2 me-2'>WK</Badge>
                            <label className='text-black fs-6'>Week End</label>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end'>
                        <></>
                        <div className='me-2'>
                            <div className='border rounded px-2 py-1 border-success bg-success-light'>
                                <label className='text-black fs-6'>Present</label>
                                <div className='d-block text-center'>
                                    <label className='text-danger fw-bold fs-3'>{percentages.present} %
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-2 py-1 border-danger bg-danger-light'>
                                <label className='text-black fs-6'>Leave</label>
                                <div className='d-block text-center'>
                                    <label className='text-danger fw-bold fs-3'>{percentages.leave} %
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-2 py-1  border-info bg-info-light'>
                                <label className='text-black fs-6'>Week End</label>
                                <div className='d-block text-center'>
                                    <label className='text-danger fw-bold fs-3'>{percentages.weekEnd} %
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-2 py-1  border-warning bg-warning-light'>
                                <label className='text-black fs-6'>Permission</label>
                                <div className='d-block text-center'>
                                    <label className='text-danger fw-bold fs-3'>{percentages.permission} %
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-2 py-1  border-dark bg-dark-light'>
                                <label className='text-black fs-6'>On Duty</label>
                                <div className='d-block text-center'>
                                    <label className='text-danger fw-bold fs-3'>{percentages.onDuty} %
                                    </label>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <div className="table-container">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Left: Show entries dropdown */}
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{  fontSize: '0.85rem', height: '30px' }}
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value));
                                        setPage(1); // Reset to first page
                                    }}
                                >
                                    {/* <option value={5}>5</option> */}
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>

                            {/* Right: Search input */}
                            <div>
                                <input
                                    type="text"
                                    style={{  fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1); // Reset page on new search
                                    }}
                                />
                            </div>
                        </div>
                        <table ref={tableRef} className="attendance_table sticky_attendance_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-50px text-start'>Staff</th>
                                    {dateKeys.map((date, index) => {
                                    const cleanedDate = date.split('(')[0]; // Removes any (Sun) if present
                                    const day = parseInt(cleanedDate.split('/')[0]);
                                    const formattedWeekday = new Date(year, selectedMonth - 1, day).toLocaleString('en-US', { weekday: 'short' });
                                    return (
                                    <th key={index} className='min-w-50px'>{cleanedDate}<br></br>{formattedWeekday}</th>
                                    );
                                })}
                                    <th className='min-w-50px'>Status</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {attendanceData.length > 0 ? (
                                    attendanceData.map((staff, index) => (
                                        <tr key={staff.staff_id}>
                                            <td>
                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                    <div className="avatar-preview">
                                                        <img
                                                            id="saveImageFile"
                                                            src={staff.staff_image ? staff.staff_image : staff2}
                                                            alt={staff.name}
                                                            className='w-60px h-60px'
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className='text-black font-w600 fs-7'>{staff.name || 'Unknown'}</label>
                                                        <span className="fs-9 text-gray-800 font-w600 d-block">{staff.shift_time || 'N/A '}</span>
                                                        <div className="d-block">
                                                            <label className="fs-8 text-white fw-bold">{staff.department || 'N/A'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            {dateKeys.map((date, idx) => {
                                                const { bg, text } = getBadgeProps(staff.attendance[date]);
                                                return (
                                                    <td key={idx} className='text-center align-content-center'>
                                                        <Badge bg={bg} className='text-white fs-8 py-0 px-2'>{text}</Badge>
                                                    </td>
                                                );
                                            })}
                                            <td className='align-content-center'>
                                                <span class="text-end">
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                        <Button variant="tp-btn-light px-2 py-1 me-1" onClick={() => {console.log('Clicked staff ID:', staff.manage_staff_id);
                                                            handleModalToggle(staff.staff_id)}} style={{ color: 'black' }}>
                                                            <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                        <Link to={'#'} >
                                                            <Button variant="tp-btn-light px-2 py-1 me-1" style={{ color: 'black' }}  onClick={() => handleModalEdit(staff)}>
                                                                <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </Link>
                                                    </OverlayTrigger>
                                                    {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                        <Button variant="tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(staff.staff_id, staff.name)} style={{ color: 'black' }} >
                                                            <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger> */}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={dateKeys.length + 2} className="text-black text-center">
                                            No attendance data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Bottom left: Showing x to y of z entries */}
                            <div>
                                {attendanceData.length > 0 ? (
                                    <span className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + attendanceData.length} of {TotalCount} entries
                                    </span>
                                ):(
                                    <span className="text-muted">
                                        Showing 0 to 0 of 0 entries
                                    </span>
                                )}
                            </div>

                            {/* Bottom right: Pagination */}
                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                    </li>
                                    ))}
                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                    </div>
                </div>
            </div>
            
            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Attendance Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default Attendance;